import { Action } from '@ngrx/store';
import { TTnaUpdateActionType } from './tna-updates.models';
import {
  TREQUEST_BULK_COMPLETE_TNA_ORDER_STEPS,
  TREQUEST_GET_TNA_ORDER_STEP_LIST,
  TRESPONSE_GET_TNA_ORDER_STEP_LIST,
  TRESPONSE_GET_TNA_ORDER_STEP,
  TREQUEST_UPDATE_TNA_STEP,
  TTnaOrderStepFetchReason,
  TUserPaginationOption,
} from '@monorepo/types';

export class GetTnaOrderStepList implements Action {
  readonly type = TTnaUpdateActionType.GetTnaOrderStepList;
  constructor(public payload: TREQUEST_GET_TNA_ORDER_STEP_LIST, public fetchReason: TTnaOrderStepFetchReason) {}
}

export class GetTnaOrderStepListSuccess implements Action {
  readonly type = TTnaUpdateActionType.GetTnaOrderStepListSuccess;
  constructor(public tnaList: TRESPONSE_GET_TNA_ORDER_STEP_LIST, public fetchReason: TTnaOrderStepFetchReason) {}
}

export class GetTnaOrderStepListFailure implements Action {
  readonly type = TTnaUpdateActionType.GetTnaOrderStepListFailure;
}

export class GetTnaOrderStep implements Action {
  readonly type = TTnaUpdateActionType.GetTnaOrderStep;
  constructor(public tosId: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number]['tosId']) {}
}

export class GetTnaOrderStepSuccess implements Action {
  readonly type = TTnaUpdateActionType.GetTnaOrderStepSuccess;
  constructor(
    public tnaStep: TRESPONSE_GET_TNA_ORDER_STEP,
    public tosId: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number]['tosId'],
  ) {}
}

export class GetTnaOrderStepFailure implements Action {
  readonly type = TTnaUpdateActionType.GetTnaOrderStepFailure;
}

export class UpdateTnaOrderStep implements Action {
  readonly type = TTnaUpdateActionType.UpdateTnaOrderStep;
  constructor(
    public payload: TREQUEST_UPDATE_TNA_STEP,
    public status: TREQUEST_GET_TNA_ORDER_STEP_LIST['status'],
    public listingPayload: TREQUEST_GET_TNA_ORDER_STEP_LIST,
  ) {}
}

export class UpdateTnaOrderStepSuccess implements Action {
  readonly type = TTnaUpdateActionType.UpdateTnaOrderStepSuccess;
}

export class UpdateTnaOrderStepFailure implements Action {
  readonly type = TTnaUpdateActionType.UpdateTnaOrderStepFailure;
}

export class BulkCompleteTnaOrderSteps implements Action {
  readonly type = TTnaUpdateActionType.BulkCompleteTnaOrderSteps;
  constructor(
    public payload: TREQUEST_BULK_COMPLETE_TNA_ORDER_STEPS,
    public listingPayload: TREQUEST_GET_TNA_ORDER_STEP_LIST,
  ) {}
}

export class BulkCompleteTnaOrderStepsFailure implements Action {
  readonly type = TTnaUpdateActionType.BulkCompleteTnaOrderStepsFailure;
}

export class SetUserPaginationOption implements Action {
  readonly type = TTnaUpdateActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export type TTnaUpdateActions =
  | GetTnaOrderStepList
  | GetTnaOrderStepListSuccess
  | GetTnaOrderStepListFailure
  | GetTnaOrderStep
  | GetTnaOrderStepSuccess
  | GetTnaOrderStepFailure
  | UpdateTnaOrderStep
  | UpdateTnaOrderStepSuccess
  | UpdateTnaOrderStepFailure
  | BulkCompleteTnaOrderSteps
  | BulkCompleteTnaOrderStepsFailure
  | SetUserPaginationOption;
